export default {
  matches(state, matches) {
    state.live.matches = matches;
  },
  match(state, { _id, match, type }) {
    let index = state.live[type].findIndex(m => m._id === _id);
    if (index >= 0) state.live[type][index] = Object.assign({}, match);
  },
  liveStatistic(state, stat) {
    state.live.stat = stat;
  },
  activeLiveCount(state, count) {
    state.live.active = count.map(m => {
      const current = state.live.active.find(({ _id }) => m._id === _id);
      m.mini = current ? current.mini : true;
      return m;
    });
  },
  setProcessingId(state, id) {
    state.live.processingId = id;
  },
  toggleMatchView(state, { id, mini }) {
    console.log({ id, mini });
    state.live.active = state.live.active.map(m => {
      if (id !== undefined) {
        if (m._id === id) m.mini = !m.mini;
      }
      if (mini !== undefined) m.mini = mini;
      return m;
    });
  }
};
